import { FC, ReactNode } from 'react'
import { Link } from '@/libs'
import { Translation } from '@/helpers'
import { BugAntIcon, FaceSmileIcon } from '@heroicons/react/16/solid'

const Error: FC<ErrorComponentProps> = (props): ReactNode => {
    const { code } = props

    return (
        <div className='h-full px-4 -mt-14 place-content-center flex justify-center flex-col items-center align-middle'>
            {code === 404 && <FaceSmileIcon className='flex-shrink-0 w-16 h-16 text-[#EBEBEB]' /> }
            {code === 500 && <BugAntIcon className='flex-shrink-0 w-16 h-16 text-[#EBEBEB]' /> }

            <h1 className='mt-6 text-2xl font-bold tracking-tight text-[#EBEBEB] sm:text-4xl'>
                {code === 404 ? Translation('404-error-title') : Translation('500-error-title')}
            </h1>

            <p className='mt-2 text-[#CDD5DA] xl:text-md text-[14px] md:w-[40%] xl-[35%] w-[75%] text-center'>
                {code === 404 ? Translation('404-error-description') : Translation('500-error-description')}
            </p>

            <Link href='/' className='select-none flex mt-4 items-center justify-center px-4 py-2 text-sm font-medium text-[#EBEBEB] rounded-md button-gradient hover:opacity-90 transition-all ease-in-out duration-500'>
                {Translation('go-back')}
            </Link>
        </div>
    )
}

export default Error
